import { render, staticRenderFns } from "./ServiceTypesForm.vue?vue&type=template&id=6e58a971"
import script from "./ServiceTypesForm.vue?vue&type=script&lang=js"
export * from "./ServiceTypesForm.vue?vue&type=script&lang=js"
import style0 from "./ServiceTypesForm.vue?vue&type=style&index=0&id=6e58a971&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports